import { gql } from "@apollo/client";

const deleteAskAiChatSessionMutation = gql`
  mutation DeleteAskAiChatSessionMutation($id: Int!) {
    deleteChatSession(id: $id) {
      id
      ok
    }
  }
`;

export default deleteAskAiChatSessionMutation;
